if (document.querySelector('.page-template-tpl-faq')) {
  const HTML = document.querySelector('html') as HTMLInputElement | null;
  const BODY = document.querySelector('body') as HTMLInputElement | null;
  HTML!.style.scrollBehavior = 'smooth';
  BODY!.style.scrollBehavior = 'smooth';
}
